import { useQuery } from '@tanstack/react-query'

import apiClient from '@/api/axios'
import { API_ENDPOINTS } from '@/api/endpoints'

import { logger } from '@/lib/logger'

import { BranchType } from '../features/branches/types/branch.types'

export type Branch = {
  id: string
  code: string
  address: string
  name: string
  description?: string | null
  phone?: string | null
  email?: string | null
  logo_url?: string | null
  banner_url?: string | null
  is_active: boolean
  work_days?: any | null
  working_hours?: any | null
  type: BranchType
}

async function fetchBranches(): Promise<Branch[]> {
  const response = await apiClient.get(API_ENDPOINTS.register.branches)
  logger.debug('fetchBranches response', response.data)
  return response?.data?.data?.data
}

export function useBranches() {
  return useQuery({
    queryKey: ['branches'],
    queryFn: fetchBranches,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  })
}
